<template>
    <div class="row my-4">
        <div v-for="item in items" class="col-12 col-md-4">
            <inertia-link :href="routeFunction(item)">
                <v-card width="100%" height="100%" link>
                    <slot name="image" :item="item">
                        <v-img
                            :src="item[imageName]"
                            width="100%"
                            :aspect-ratio="imageAspect"
                            :contain="!dontContain"
                        />
                    </slot>

                    <v-card-title
                        v-if="!hideTitle"
                        class="secondary--text d-flex align-center text-h6"
                    >
                        <span v-text="item[titleName]" />
                    </v-card-title>

                    <v-card-subtitle v-if="!hideTitle" class="primary--text">
                        <slot name="subtitle" v-bind:item="item" />
                    </v-card-subtitle>
                </v-card>
            </inertia-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleryGrid",

    props: {
        items: {
            type: Array,
            required: true,
        },
        imageName: {
            type: String,
            default: "image",
        },
        iconName: {
            type: String,
            default: "icon_url",
        },
        titleName: {
            type: String,
            default: "name",
        },
        routeFunction: {
            type: Function,
            required: true,
        },
        hideTitle: {
            type: Boolean,
            default: false,
        },
        dontContain: {
            type: Boolean,
            default: false,
        },
        imageAspect: {
            default: 1.5,
        },
    },
};
</script>

<style scoped></style>
